import { Routes } from '@angular/router';
import { AuthenticationGuard } from '@softline/auth';
import { SOFTLINE_PERMISSION_AI_AGENT } from './ai-agent.shared';

export const aiAgentRoutes: Routes = [
  {
    path: 'ai-agent',
    canActivate: [AuthenticationGuard],
    data: { permission: SOFTLINE_PERMISSION_AI_AGENT },
    // No route providers: the shell panel renders the conversation outside this
    // route, and page and panel must share one thread — see ai-agent.providers.
    children: [
      { path: '', redirectTo: 'chat', pathMatch: 'full' },
      {
        path: 'chat',
        loadComponent: () =>
          import('./pages/chat/chat.component').then((m) => m.AiAgentChatComponent),
      },
    ],
  },
];
